import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuardService } from 'src/app/services/guard/guardService.service';
import { PageModernPreloadComponent } from 'src/app/components/pages/page-modern-preload/page-modern-preload.component'


const routes: Routes = [
	{
		path: '',
		component: PageModernPreloadComponent,
		canDeactivate: [GuardService],
		canActivate: [ GuardService ],
		data: {
			pageName: 'Modern Preload'
		}
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ModernPreloadMFRoutingModule { }
